import { HydrateAction, hydrateType } from '../../HydrateAction';
import { SagaGenerator, actionChannel, call, take } from 'typed-redux-saga';
import trackSessionActions, {
  SessionActionType,
  TrackSessionActionsType
} from '../../../tracking/trackSessionActions';
import { CartTypeQuantityData } from '../../../tracking/pushToDataLayer';
import { Channel } from 'redux-saga';
import { OptionalStateCarts } from '../../carts/CartsState';
import { calculateCartQuantities } from '../../../tracking/calculateCartQuantities';

function* handleCartStateChanges(
  cartQuantityData: CartTypeQuantityData,
  anonymousUserId: string | null,
  authenticatedUserId: string | null
): SagaGenerator<void> {
  const actionType: TrackSessionActionsType = { type: SessionActionType.LOGIN };

  yield* call(
    trackSessionActions,
    actionType,
    anonymousUserId,
    authenticatedUserId,
    cartQuantityData
  );
}

function* watchLoginActionTrackingSaga(): SagaGenerator<void> {
  const hydrateAction: Channel<HydrateAction> = yield* actionChannel<HydrateAction>([hydrateType]);

  let oldAuthenticatedUserId: string | null = null;
  while (true) {
    const action: HydrateAction = yield* take(hydrateAction);
    if (!action.payload.auth || !action.payload.carts || !action.payload.session) {
      continue;
    }
    if (action.payload.auth.authenticatedUserId !== oldAuthenticatedUserId) {
      const currentCartState: OptionalStateCarts = action.payload.carts.carts;
      const anonymousUserId: string | null = action.payload.session.content?.guid ?? null;
      const authenticatedUserId: string | null = action.payload.auth.authenticatedUserId;
      const cartQuantityData = calculateCartQuantities(currentCartState);

      yield* handleCartStateChanges(cartQuantityData, anonymousUserId, authenticatedUserId);
    }
    oldAuthenticatedUserId = action.payload.auth.authenticatedUserId;
  }
}

export default watchLoginActionTrackingSaga;
